import { Filter } from "interfaces/filters";

export const saveDataToSessionStorage = (name: string, payload: any) => {
  sessionStorage.setItem(name, JSON.stringify(payload));
};

export const readDataFromSessionStorage = (name: string) => {
  const sessionData = sessionStorage.getItem(name);
  if (!sessionData) return null;

  const sessionDataParsed = JSON.parse(sessionData);
  if (Array.isArray(sessionData) && sessionDataParsed.length === 0) return null;

  return sessionDataParsed;
};

export const clearSessionStorage = () => {
  sessionStorage.clear();
};

export const readFiltersFromSessionStorage = () => {
  return readDataFromSessionStorage(`filters_${window.location.pathname}`);
};

export const saveFiltersToSessionStorage = (filtersToApply: Filter[] | {}) => {
  saveDataToSessionStorage(`filters_${window.location.pathname}`, filtersToApply);
};
